module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("electron-cheatsheet")]), _vm._v(" "), _c('search', {
    on: {
      "query": function($event) {
        _vm.searchSettings = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "modules"
    }
  }, _vm._l((_vm.filteredModules), function(module, key) {
    return _c('module', {
      key: key,
      attrs: {
        "module": module,
        "name": key
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcd11940"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 52
// module chunks = 1